import { ProductDesign } from '@inter-ikea-storageone/range';

export enum OptionType {
  changeColour,
  changeDepth,
  changeDepthAndColour
}

export type ChangeFrame = {
  type: OptionType;
  possibleToChange: boolean;
};

export type Depth = {
  value: number;
  text: string;
};

export type Colour = {
  value: ProductDesign;
  text: string;
};

export type OptionValue = {
  depth?: Depth;
  colour?: Colour;
  available: boolean;
};
